import React from 'react'
import { sizes } from './const'
export interface LoadingProps {
    /**
     * This allows to pass a custom className to the component.
     * i.e. className="js_TrackIcon", which is used for Google Analitics.
     */
    className?: string
    /**
     * The size we can use for the icon: small, medium, large.
     * small = 16px, medium = 24px, large = 32px.
     *
     */
    size?: 'small' | 'medium' | 'large'
}

export const LoadingIcon = ({
    className = 'js_loadingIcon',
    size = 'medium',
}: LoadingProps) => {
    return (
        <svg
            viewBox="0 0 100 100"
            preserveAspectRatio="xMidYMid"
            className={`stroke-brand-black ${className} ${sizes[size]}`}
            data-testid="loading-svg"
        >
            <circle
                cx={50}
                cy={50}
                fill="none"
                strokeWidth={10}
                r={44}
                strokeDasharray="207.34511513692632 71.11503837897544"
                transform="rotate(156 50 50)"
            >
                <animateTransform
                    attributeName="transform"
                    type="rotate"
                    calcMode="linear"
                    values="0 50 50;360 50 50"
                    keyTimes="0;1"
                    dur="1s"
                    begin="0s"
                    repeatCount="indefinite"
                />
            </circle>
        </svg>
    )
}
